module.exports = __webpack_public_path__ + "img/feature_5.edf9391d.svg";